import React from 'react';
import { FormattedNumber, IntlProvider } from 'react-intl';

const CurrencyFormatter = ({ value }) => {
  return (
    <IntlProvider locale={'tr'} defaultLocale="en">
    <FormattedNumber
      maximumFractionDigits={2}
      minimumFractionDigits={2}
      value={value ? value : 0}
      style={'decimal'}
    /> TL
  </IntlProvider>
  );
};

export default CurrencyFormatter;